import { render } from "./Characters_Table.vue?vue&type=template&id=7a570ef1"
import script from "./Characters_Table.vue?vue&type=script&lang=js"
export * from "./Characters_Table.vue?vue&type=script&lang=js"

import "./Characters_Table.vue?vue&type=style&index=0&id=7a570ef1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__